import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SHOPIFY_INTEGRATION_TYPE, WOO_COMMERCE_INTEGRATION_TYPE } from '../../../../../../constants/integrationTypes';
import { InfoTitle } from '../../../../../common/InfoTooltip';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export function AutoGenerateAccountIdTooltip({ option, hasGeneratedValue = false, styles }) {
  const knownAutoGenerateIntegrationType = {
    [SHOPIFY_INTEGRATION_TYPE]: 'Shopify',
    [WOO_COMMERCE_INTEGRATION_TYPE]: 'WooCommerce',
  };

  const autoGenerateType =
    knownAutoGenerateIntegrationType[option.orders_integration_type] ?? "your warehouse's integration type";

  const tooltipText = hasGeneratedValue
    ? `This is the generated customer account id from ${autoGenerateType}`
    : `The value you add to this field will be used as the customer name in ${autoGenerateType}'s platform.`;
  const additionalTooltipText = !hasGeneratedValue && 'Once saved, the new account ID will appear on this line';

  return (
    <div className={styles.auto_generate_account_id_tooltip}>
      <InfoTitle
        content={
          <div>
            <p>{tooltipText}</p>
            {additionalTooltipText && <p>{additionalTooltipText}</p>}
          </div>
        }
      >
        <FontAwesomeIcon icon={faInfoCircle} />
      </InfoTitle>
    </div>
  );
}
